import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class FileService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

  getFiles(){
    let url = 'dashboard/view_files'
    return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }

  uploadFile(photo){
    let url = 'dashboard/upload_file';
    const f = new FormData;
    f.append('image_file',photo)
    return this.http.post(this.BASE_URL_API + url, f,this.storage.getHeaders())
  }

}
